import { BaseEntityModel } from '../../../core/abstractions/base-entity.model';
import { BaseSearchResource } from '../../../core/abstractions/base-search.resource';
import { RelatedItemModel } from '../../../models/core/related-item.model';
import { DictionaryType } from '../../../models/types/dictionary.type';
import { PagedGridComponent } from '../paged-grid.component';
import { GridColumnConfig } from './grid-column.config';

export class GridConfig<T extends BaseEntityModel> {
    pageSize = 10;
    resource: BaseSearchResource<T>;
    columns: GridColumnConfig[] = [];
    name: string;
    canExport = true;
    hasNewButton = false;
    hasEditButton = false;
    hasViewButton = false;
    hasRemoveButton = false;
    typeName: string;
    extraProperties?: DictionaryType<any> = undefined;
    relatedActionsHandler?: (relatedItem: RelatedItemModel, grid: PagedGridComponent<T>) => void;

    constructor(init?: Partial<GridConfig<T>>) {
        Object.assign(this, init);
    }
}
